import { combineReducers } from "redux";
import { tutorialsState } from "./videotutorialsReducer";

export const tutorialsReducers = combineReducers({
    tutorialsState: tutorialsState
});
